import React from "react";
import { getStyle, notFilledInputClass, notFilledSelectClass, regularInputClass, regularSelectClass } from "../../styles/styles"
import { Breadcrumb } from "antd";
import NumberInput from "../shared/NumberInput";
import { formatDate, formatToCurrencyWithScale, getScaleByCurrency, roundAmountByCurrency } from "../../helpers/FormatHelper";
import DynamicSelect from "../shared/DynamicSelect";
import { getCurrenciesDenominationsByCustomer } from "../../networking/NetworkingCurrencies";
import { getInstrumentsByCustomer } from "../../networking/NetworkingInstruments";
import { GlobalSystemParametersNames } from "../../constants/GlobalSystemParametersNames";
import { getBankAccountsByCurrency, getCustomerByID } from "../../networking/NetworkingCustomers";
import { getNostroBankAccountsForFunds, getVirtualBankAccountsByCurrencyID } from "../../networking/NetworkingBankAccounts";
import DatePicker from "../shared/DatePicker";
import { getBeneficiariesByCustomer } from "../../networking/NetworkingBeneficiaries";
import DynamicSelectWithSearch from "../shared/DynamicSelectWithSearch";
import LoadingBox from "../shared/LoadingBox";
import AlertBox from "../shared/AlertBox";
import { getParametersByName } from "../../networking/NetworkingGlobalSystemParameters";
import { applySettlement, getListOfSettlementsForCustomer, getSettlement, getSettlementsWithBalanceByCustomerCurrency, saveSettlements, unapplySettlement, voidSettlement } from "../../networking/NetworkingSettlement";
import { getDefaultPagingNumberOfItems } from "../../helpers/PackageJsonHelper";
import EntityProperties from "../shared/EntityProperties"
import { SettlementType } from "../../constants/EntityTypeNames";
import NewDynamicTable from "../shared/NewDynamicTable";
import { getOrdersForSettlements } from "../../networking/NetworkingBankNotes";
import Paginator from "../shared/Paginator";
import { getListOfBanks } from "../../networking/NetworkingBanks";

const SettlementsApplied = ({ settlements = [], rowClick = f => f, unlinkSettlement = f => f, orderUpdateToken, readOnly, currencyId }) => {

    let controlId = 'CSettlementsApplied'

    const headersForSettlementsApplied = (
        <tr style={{ textAlignLast: 'center' }}>
            <th>SETTLEMENT ID</th>
            <th>APPLICATION STATUS</th>
            <th>ORIGINAL AMOUNT</th>
            <th>Amount Applied</th>
            {!readOnly && <th>Actions</th>}
        </tr>
    );

    let rowsForSettlementsApplied = []
    let index = 0

    settlements.forEach((element, i) => {
        index++;
        let voidAction;

        element.CanBeVoided = 1
        element.OrderUpdateToken = orderUpdateToken

        if (Number(element['Settlement ID']) > 0 && element['Settlement Status'] === 'Confirmed') {
            voidAction = (
                <i
                    className="fa fa-chain-broken"
                    onClick={() => unlinkSettlement(element)}
                    style={{
                        fontSize: '1.75em',
                        verticalAlign: 'middle'
                    }}
                    title={'Unapply'}
                />
            );            
        }    

        let value_settlementID = element['Settlement ID'];

        rowsForSettlementsApplied.push(
            <tr key={controlId + 'row' + index} onClick={() => rowClick(value_settlementID)} >
                <td style={{ textAlign: 'center' }}>{value_settlementID}</td>
                <td style={{ textAlign: 'center' }}>{element['Settlement Status']}</td>
                <td style={{ textAlign: 'right' }}>{formatToCurrencyWithScale(element['Amount'], currencyId)}</td>
                <td style={{ textAlign: 'right' }}>{formatToCurrencyWithScale(element['Amount Used'], currencyId)}</td>
                {!readOnly &&
                    <td
                        style={{
                            textAlign: "center",
                            verticalAlign: 'middle'
                        }}
                    >
                        {voidAction}
                    </td>
                }
            </tr>
        )
    });
    
    return <li className="uk-open">
        <h5 className={"uk-accordion-title"}>Order Application</h5>
        <div className="uk-accordion-content" style={{ backgroundColor: '#f8f8f8' }}>
            <div id="settlements-applied-to-order">
                <div className="uk-width-1-1" id="settlements-applied-to-order-component">
                    <div className="uk-width-1-1 border-table">
                        <table className="uk-table uk-table-striped uk-table-hover uk-table-divider" hidden={rowsForSettlementsApplied.length === 0}>
                            <thead>
                                {headersForSettlementsApplied}
                            </thead>
                            <tbody>
                                {rowsForSettlementsApplied}
                            </tbody>
                        </table>
                    </div>
                    <h5 style={style.alignCenter} hidden={rowsForSettlementsApplied.length > 0}>No records found.</h5>
                </div>
            </div>
        </div>
    </li>
}

const SettlementsNotApplied = ({ settlements = [], rowClick = f => f, handleAmountToUse = f => f, handleNewAppy = f => f,
    orderNo, selectedSettlementId, orderUpdateToken, readOnly, currencyId}) => {

    let controlId = 'CSettlementsNoApplied'
    
    const headersForSettlementsNoApplied = (
        <tr style={{ textAlignLast: 'center' }}>
            <th>Settlement ID</th>
            <th>Settlement Status</th>
            <th>Settlement Amount Total</th>
            <th>Outstanding Balance</th>
            <th>Amount Applied</th>
            {!readOnly && <th>Actions</th>}
        </tr>
    );
    
    let rowsForSettlementsNoApplied = []
    let index = 0

    settlements.forEach((element, i) => {
        index++;
        element.OrderUpdateToken = orderUpdateToken

        let amountControl = (
            <NumberInput id={controlId + 'noapplied-amounttouse-' + index} 
                type="Currency"
                value={element['AmountToUse']}
                className='uk-input'
                disabled={readOnly || selectedSettlementId !== element['Settlement ID']}
                onChange={(event) => handleAmountToUse(
                    {
                        recordID: element['Settlement ID'],
                        typeRecord: 'Order',
                        pendingAmount: element['Outstanding Balance'],
                        amount: element['Amount'],
                        orderUpdateToken: orderUpdateToken,
                        source: 'listCustomerSettlements',
                        status: element['Status']
                    }, event.target.value)}
            />
        )
        
        let applySettlementAction = (
            <i
                className="fa fa-money"
                onClick={() => handleNewAppy({ ...element, recordID: '' + orderNo }, i)}
                style={{
                    fontSize: '1.25em',
                    verticalAlign: 'middle',
                    cursor: 'pointer',
                    paddingLeft: '10px',
                    paddingRight: '10px'
                }}
                title={'Apply'}
            />
        );

        if (selectedSettlementId === element['Settlement ID']) {
            rowsForSettlementsNoApplied.push(
                <tr key={controlId + 'row' + index}>
                    <td style={{ textAlign: 'center' }}>{element['Settlement ID']}</td>
                    <td style={{ textAlign: 'center' }}>{element['Status']}</td>
                    <td style={{ textAlign: 'right' }}>{formatToCurrencyWithScale(element['Amount'], currencyId)}</td>
                    <td style={{ textAlign: 'right' }}>{formatToCurrencyWithScale(element['Outstanding Balance'], currencyId)}</td>
                    <td>
                        {amountControl}
                    </td>
                    {!readOnly &&
                        <td
                            style={{
                                textAlign: "center",
                                verticalAlign: 'middle'
                            }}
                        >
                            {applySettlementAction}
                        </td>
                    }
                </tr>
            )
        } else {
            rowsForSettlementsNoApplied.push(
                <tr key={controlId + 'row' + index}
                    onClick={() => rowClick(element['Settlement ID'])}>
                    <td style={{ textAlign: 'center' }}>{element['Settlement ID']}</td>
                    <td style={{ textAlign: 'center' }}>{element['Status']}</td>
                    <td style={{ textAlign: 'right' }}>{formatToCurrencyWithScale(element['Amount'], currencyId)}</td>
                    <td style={{ textAlign: 'right' }}>{formatToCurrencyWithScale(element['Outstanding Balance'], currencyId)}</td>
                    <td>
                        {amountControl}
                    </td>
                    {!readOnly &&
                        <td
                            style={{
                                textAlign: "center",
                                verticalAlign: 'middle'
                            }}
                        >
                            {applySettlementAction}
                        </td>
                    }
                </tr>
            )
        }
    })
    
    return <li className="uk-open">
        <h5 className="uk-accordion-title">Settlements No Applied</h5>
        <div className="uk-accordion-content" style={{ backgroundColor: '#f8f8f8' }}>
            <div id={controlId + "settlement-no-applied-to-order"}>
                <div className="uk-width-1-1" id="settlements-no-applied-to-order-component">
                    <div className="uk-width-1-1 border-table">
                        <table className="uk-table uk-table-striped uk-table-hover uk-table-divider" hidden={rowsForSettlementsNoApplied.length === 0}>
                            <thead>
                                {headersForSettlementsNoApplied}
                            </thead>
                            <tbody>
                                {rowsForSettlementsNoApplied}
                            </tbody>
                        </table>
                    </div>
                    <h5 style={style.alignCenter} hidden={rowsForSettlementsNoApplied.length > 0}>No records found.</h5>
                </div>
            </div>
        </div>
    </li>
}

const deliveryMethodBranch = 'At the branch';
var style = getStyle();
export default class SettlementApplicationForm extends React.Component {
    state = {
        column: '',
        direction: '',
        amount: 0,
        beneficiaryId: 0,
        chequeBankId: 0,
        chequeDate: '',
        chequeNumber: '',
        createdOn: '',
        currencyID: '',
        currentElementToApply : null,
        customerBankAccountId: 0,
        customerID: 0,
        customerName: '',
        dateReceived: '',
        deliveryMethod: '',
        disbursedAmount: 0,
        endDate: new Date(),
        entityPropertiesSaveProcess: false,
        lockedSide: 'Sell',
        nostroBankAccountId: 0,
        outstandingBalance: 0,
        readOnly: false,
        refundedAmount: 0,
        saveInPendingStatus: false,
        selectedSettlement: {},
        sessionLastClosingDate: '',
        sessionSystemDate: '',
        settlementID: 0,
        settlementInstrument: '',
        settlementReferenceNo: '',
        settlementStatus: '',
        showApplyCurrentSettlementsAlert: false,
        showApplySettlementsAlert: false,
        showDirectDebitFields: false, 
        showETFFields: false,
        showLinkedSettlements: true,
        systemDate: '',
        thirdPartyBeneficiarySettlement: false,
        updatedOn: '',
        updateToken: 0,
        validations: {
            currencyId              : true,
            amount                  : true,
            dateReceived            : true,
            settlementInstrument    : true,
            deliveryMethod          : true,
            customerBankAccountId   : true,
            nostroAccountId         : true,
            inputAmountList         : [],
            chequeNumber            : true,
            chequeDate              : true,
            chequeBankId            : true
        },
        //defaults
        defaultDeliveryMethod: '',
        defaultNostroBankID: 0,
        defaultSettlementInstrument: '',
        //lists
        listActiveCurrencies: [],
        listBanks: [],
        listCustomerBankAccounts: [],
        listCustomerSettlements: [],
        listDeliveryMethods: {},
        listIncomingInstruments: [],
        listNostroAccounts: [],
        listThirdPartyBenes: [],
        listToApply: [],
        listToApplyView: [],
        //alert
        alertMessage: '',
        alertMessageSave: '',
        alertTitle: '',
        confirmCurrentElementMessage: '',
        messageVoid: "Are you sure you want to void this settlement?",
        messageUnapplied: "Are you sure you want to unapply this settlement?",
        showApplySettlementsAlert: false,
        showAlert: false,
        showAlertSave: false,
        showVoidSettlementAlert: false,
        showUnapplySettlementAlert: false,
        //balance
        currentSettlementBal: 0,
        combinedBalance: 0,    
        //Checkbox
        saveAmountCombined: 0,
        selectedRows: [],
        //paginator
        currentPage: 1,
        loading: false,
        loadingSettlements: false,
        newSearch: false,
        totalPages: 0,
        //unapply
        settlementElementToUnapply: {},
    }

    async componentDidMount(){
        this.setState({loading: true});
        let sessionSystemDate = localStorage.getItem(GlobalSystemParametersNames.SystemDate);
        let sessionLastClosingDate = localStorage.getItem(GlobalSystemParametersNames.LastClosingDate);
        //this.loadBeneficiaries();
        if (!this.props.settlementOpenFromBoard) {
            let customerID = this.props.customerID;
            //let listActiveCurrencies = this.props.activeCurrencies;
            /*listActiveCurrencies.forEach(element => {
                element.value = element.CurrencyID;
                element.name = element.CurrencyIDName;
            });*/
            this.getOrdersForSettlements_intern(customerID, '', 0);
            this.loadCurrencyList(customerID);
            var currencyID = '';
            if (this.props.buyCurrency !== undefined) {
                currencyID = this.props.buyCurrency;
                await this.loadNostroBankAccounts(currencyID);
            }
            
            //Load instrument
            this.loadCustomerInstruments(customerID);

            //Load settlements
            this.loadSettlementsForCustomer(customerID, true);

            this.getCustomerInformation(customerID);

            var settlementID = 0
            var orderAmount = 0
            if(this.props.orderAmount) { orderAmount = this.props.orderAmount }
            if(this.props.orderCurrencyID) { currencyID = this.props.orderCurrencyID }
            this.setState({
                amount: orderAmount,
                currencyID: currencyID,
                customerID: customerID,
                dateReceived: new Date(sessionSystemDate),
                //listActiveCurrencies: listActiveCurrencies,
                settlementID: settlementID,
                sessionLastClosingDate: sessionLastClosingDate,
                sessionSystemDate: sessionSystemDate,
            });

            if (Number(this.props.data) > 0) {//settlementID
                settlementID = this.props.data;
                this.loadSettlement(settlementID, false, false);
            } else {
                let systemDate = localStorage.getItem(GlobalSystemParametersNames.SystemDate);
                
                var showETFFields = false;
                if (this.state.defaultSettlementInstrument === 'Electronic Funds Transfer') {
                    showETFFields = true;
                }

                var showDirectDebitFields = false;
                if (this.state.defaultSettlementInstrument === 'Direct Debit') {
                    showDirectDebitFields = true;
                }

                if (this.state.defaultSettlementInstrument === 'Cheque') {
                    this.loadListOfBanks();
                } else {
                    this.setState({ listBanks: [] });
                }
            }
        } else {
            this.loadCurrencyList(this.props.customerID).then(() => {
                if (Number(this.props.data) > 0) {//SettlementID
                    this.loadSettlement(this.props.data, true, true); 
                } else {                    
                    let systemDate = localStorage.getItem(GlobalSystemParametersNames.SystemDate);

                    var showETFFields = false;
                    if (this.state.defaultSettlementInstrument === 'Electronic Funds Transfer') {
                        showETFFields = true;
                    }

                    var showDirectDebitFields = false;
                    if (this.state.defaultSettlementInstrument === 'Direct Debit') {
                        showDirectDebitFields = true;
                    }

                    if (this.state.defaultSettlementInstrument === 'Cheque') {
                        this.loadListOfBanks();
                    } else {
                        this.setState({ listBanks: [] });
                    }
                
                    this.setState({ 
                        amount               : this.props.totalDue,
                        dateReceived         : systemDate !== ''? systemDate: '',
                        settlementInstrument: this.state.defaultSettlementInstrument || '',
                        deliveryMethod       : this.state.defaultDeliveryMethod,
                        showETFFields        : showETFFields,
                        showDirectDebitFields: showDirectDebitFields
                    });
                }
            })
        }
        
        //Set state
        this.setState({ loading:false });
    }

    async componentDidUpdate(prevProps){
        if(prevProps.orderInfo !== undefined && this.props.orderInfo !== undefined) { }
    }

    async loadSettlement(settlementID, loadSettlements, loadCustomerInstruments) {
        this.setState({loading: true});
        getSettlement(settlementID).then(
            (response) => {
                if (typeof response !== "undefined") {
                    console.log(response['NostroBankAccountID']);
                    this.setState({
                        amount: response['AmountReceived'],//response['OutstandingBalance'],
                        currencyID: response['Currency ID'],
                        dateReceived: response['DateReceived'],
                        deliveryMethod: response['SettlementMethod'],
                        nostroBankAccountId: response['NostroBankAccountID'],
                        settlementID: response['Settlement ID'],
                        settlementStatus: response['Status'],
                        updateToken: response.UpdateToken,
                        paymentStatus: response.Status,
                        settlementInstrument: response.SettlementInstrument,
                        createdOn: response.CreatedOn,
                        updatedOn: response.UpdatedOn,
                        customerID: response['CustomerID'],
                        chequeNumber: response.ChequeNumber,
                        chequeBankId: response.ChequeBankId,
                        chequeDate: response.ChequeDate,
                        selectedSettlement: response,
                        settlementReferenceNo: response['SettlementReferenceNo'],
                        outstandingBalance: response['OutstandingBalance']
                    }, () => {
                        var showETFFields = false;
                        if (this.state.settlementInstrument === 'Electronic Funds Transfer') {
                            showETFFields = true;
                        }

                        var showDirectDebitFields = false;
                        if (this.state.settlementInstrument === 'Direct Debit') {
                            showDirectDebitFields = true;
                        }

                        if (this.state.settlementInstrument === 'Cheque') {
                            this.loadListOfBanks();
                        } else {
                            this.setState({ listBanks: [] });
                        }

                        this.loadBankAccountsByCurrency(response['Customer ID'], response['Currency ID'],)
                        this.loadNostroBankAccounts(response['Currency ID']);

                        var deliveryMethod = response.DeliveryMethod;

                        this.getOrdersForSettlements_intern(response['Customer ID'], response['Currency ID'], settlementID);
                        this.getSettlementsWithBalanceByCustomerAndCurrency(response['Customer ID'], response['Currency ID']);

                        this.getCustomerInformation(response['Customer ID']);
                        if (loadSettlements) {
                            this.loadSettlementsForCustomer(response['Customer ID'], true);
                        }
                        if (loadCustomerInstruments) {
                            this.loadCustomerInstruments(response['Customer ID']);
                        }
                        if(this.state.customerID === undefined) {
                            this.loadCurrencyList(response['Customer ID']);
                        }
                        this.calculateBalance();
                        this.setState({ deliveryMethod: deliveryMethod,
                            settlementInstrument: response.SettlementInstrument,
                            showDirectDebitFields: showDirectDebitFields,
                            showETFFields: showETFFields,
                            loading: false,
                            customerID: response['Customer ID']
                        }); 
                    })
                } else{
                    this.setState({ loading: false, selectedSettlement: {} });
                }
            }
        )
    }

    loadSettlementsForCustomer(customerID, newSearch) {
        this.setState({loadingSettlements: true});
        var withAvailableBalance = false;

        var currencyID = '';
        if (this.props.buyCurrency !== undefined) {
            currencyID = this.props.buyCurrency;
        }

        getListOfSettlementsForCustomer(customerID, currencyID, this.props.orderNo, withAvailableBalance, this.state.showFullyApplied, this.props.lockedSide, this.state.currentPage, getDefaultPagingNumberOfItems()).then(
            response => {          
                var listCustomerSettlements = [];
                var pages = 1;
                if (response !== undefined) {
                    if (response.customerSettlements !== undefined) {
                        listCustomerSettlements = response.customerSettlements;
                    }
                    var totalCount = response.totalCount;
                    pages = Math.ceil(totalCount / getDefaultPagingNumberOfItems());
                }
                this.setState({
                    listCustomerSettlements: listCustomerSettlements,
                    loadingSettlements: false,
                    totalPages: pages,
                    newSearch: newSearch
                });
            }
        )/*.then(x => {
            if (this.props.dealHeaderID > 0) {
                this.loadIncomingFunds()
            }
        });*/
    }

    async loadCurrencyList(customerId) {
        /*getCurrencyList().then(
            (response) => {
                if (typeof response !== "undefined") {
                    let currencies = response.currencies;
                    currencies.forEach(element => {
                        element.value = element.CurrencyID;
                        element.name = element.CurrencyIDName;
                    });
                    this.setState({
                        listActiveCurrencies: currencies
                    });
                }
            }
        )*/
       if(customerId > 0) {
            const currenciesResponse = await getCurrenciesDenominationsByCustomer(customerId);
            if(currenciesResponse && currenciesResponse.currencies) {
                    const formattedCurrencies = currenciesResponse.currencies.map(c => ({ ...c, name: c.CurrencyIDName, value: c.CurrencyID }));
                    const finalCurrencies = [];
                    formattedCurrencies.forEach(element => {
                        switch (element.Type) {
                            case 'Settlement':
                                finalCurrencies.push(element);
                                break;
                            default:
                                break;
                        }
                    });
                    finalCurrencies.forEach(element => {
                        element.value = element.CurrencyID;
                        element.name = element.CurrencyIDName;
                    });
                    this.setState({ listActiveCurrencies: finalCurrencies });
                }
       }
    }

    getCustomerInformation(customerID) {
        getCustomerByID(customerID).then(
                (response) => {
                    this.setState({customerName: response.Name});
                }
            )
    }
    loadCustomerInstruments(customerID) {
        getInstrumentsByCustomer(customerID).then(
            (json) => {
                let jsonInstruments = json.instruments;
                if (jsonInstruments !== undefined) {
                    var incomingHelper = [];
                    var listDeliveryMethods = {};
                    for (var i = 0; i < jsonInstruments.length; i++) {
                        var instrumentElement = {
                            value: jsonInstruments[i].Instrument,
                            name: jsonInstruments[i].Instrument
                        };
                        var methodsList;
                        if (jsonInstruments[i].InstrumentType === 'Incoming' && jsonInstruments[i].Instrument !== "Client's Vostro Account") {
                            var addItem = true;
                            /*if(this.state.fromSettlements)
                            {
                                methodsList = jsonInstruments[i].DeliveryMethods.split('§');
                                if(!methodsList.find(method => method === deliveryMethodBranch))
                                {
                                    addItem = false;
                                }
                            }*/
                            if(addItem)
                            {
                                incomingHelper.push(instrumentElement);
                            }
                        }

                        //Load delivery methods
                        var deliveryMethods = [];
                        if (jsonInstruments[i].DeliveryMethods !== '') {
                            methodsList = jsonInstruments[i].DeliveryMethods.split('§');
                            /*if(this.state.fromSettlements)
                            {
                                var itemBranch = { value: deliveryMethodBranch, name: deliveryMethodBranch };
                                deliveryMethods.push(itemBranch);
                            }
                            else
                            {*/
                                for (var j = 0; j < methodsList.length; j++) {
                                    var item = { value: methodsList[j], name: methodsList[j] };
                                    deliveryMethods.push(item);
                                }
                            //}
                            listDeliveryMethods[jsonInstruments[i].Instrument] = deliveryMethods;
                        }
                    }
                    this.setState({
                        listIncomingInstruments: incomingHelper,
                        listDeliveryMethods: listDeliveryMethods,
                    });
                }
            }
        )
    }

    getOrdersForSettlements_intern(customerID, currencyID, settlementID) {
        //if(this.state.settlementStatus !== 'Pending') {
            //if (settlementID !== undefined && settlementID > 0) {
                var lockedSide = "Sell"
                if(this.props.lockedSide === 'Received') { lockedSide = "Buy"}
                getOrdersForSettlements(customerID === 0 ? this.state.customerID : customerID, currencyID, lockedSide, settlementID, 1, 1000).then(
                    (value) => {
                        var orders = [];
                        var list = [];

                        if (value !== undefined && value.totalCount > 0) {
                            if (this.props.orderNo !== undefined) {

                            } else {
                                orders = value.result;
                            }                   
                        }

                        if(orders !== undefined && orders !== null && orders.length > 0){
                            orders.forEach(element => {
                                list.push(true);
                            });
                        }
                        this.setState({ 
                            listToApplyView : orders,
                            listToApply     : [],
                            validations: {...this.state.validations, inputAmountList: list}
                        });
                    }
                )
            //}
        //}
    }

    handleBackLink = () => {
        this.props.backLink();
    }

    //events
    getAmountValue(event) {
        let value = event.target.value;
        value = value.toString().replace(',','');
        let amountEntered = Number(value);
        this.setState({ amount: amountEntered });
    }

    handleCurrencyUpdate = (obj) => {
        if (obj !== undefined && obj.value !== undefined) {
            this.setState({currencyID: obj.value},
                () => {
                    this.loadBankAccountsByCurrency(this.state.customerID, obj.value);
                    this.loadNostroBankAccounts(obj.value);
                    this.getOrdersForSettlements_intern(0, obj.value, this.state.settlementID);
                    /*this.getCustomerFundOnHoldBalanceByCurrencyJson(this.state.customerID, obj.value);
                    this.getPaymentsWithBalanceByCustomerCurrency(this.state.customerID, obj.value);   */                 
                }
            );
        }
    }

    handleIncomingInstrument = (value) => {
        if (typeof value !== "undefined" && value !== null && typeof value.value !== "undefined") {
            this.setState({
                settlementInstrument: value.value, showETFFields: false, showDirectDebitFields: false, thirdPartyBeneficiarySettlement: false, listBanks: []
            }, () => {
                /*if(this.state.fromSettlements)
                {
                    this.setState({deliveryMethod: deliveryMethodBranch})
                }*/
                if (this.state.settlementInstrument === 'Electronic Funds Transfer') {
                    this.setState({ showETFFields: true });
                }

                if (this.state.settlementInstrument === 'Direct Debit') {
                    this.setState({ showDirectDebitFields: true });
                }

                if (this.state.settlementInstrument === 'Cheque') {
                    this.loadListOfBanks();
                }
            });
        }
    }

    handleOnCheckThirdPartyBeneficiarySettlement(event) {
        let checked = event.target.checked
        this.setState({
            thirdPartyBeneficiarySettlement: checked
        }, () => {
            if (checked) {
                this.loadBankAccountsByCurrency(this.state.customerID, this.state.currencyID);
            } else {
                this.setState({ beneficiaryId: 0 })
            }
        });
    }

    handleChequeNumber(event) {
        this.setState({ chequeNumber: event.target.value });
    }
    
    handleChequeDate(date) {
        if (date !== undefined) {
            this.setState({
                chequeDate: formatDate(date)
            });
        } else {
            this.setState({ chequeDate: '' });
        }
    }
    
    handleDeliveryMethod = (obj) => {
        if (obj !== undefined 
            && obj !== null 
            && obj.value !== undefined) {
            this.setState({deliveryMethod: obj.value});
        }
    }
    
    handleCustomerBankAccount(value) {
        if (typeof value !== "undefined" && value !== null && typeof value.value !== "undefined") {
            this.setState({ customerBankAccountId: value !== null ? value.value : 0 });
        }
    }
    
    handleDateReceived(date) {
        if (date !== undefined) {
            this.setState({
                dateReceived: formatDate(date)
            });
        } else {
            this.setState({
                dateReceived: ''
            });
        }
    }

    handleBeneficiaryId(value) {
        if (typeof value !== "undefined" && value !== null && typeof value.value !== "undefined") {
            this.setState({ beneficiaryId: value !== null ? value.value : 0 })
        }
    }

    handleChequeBank(value) {
        if (typeof value !== "undefined" && value != null && typeof value.value !== "undefined") {
            this.setState({ chequeBankId: value !== null ? value.value : 0 })
        }
    }

    handleSettlementReferenceNo(event) {
        this.setState({ settlementReferenceNo: event.target.value });
    }

    handleNostroBankAccount(value) 
    {
        if (typeof value !== "undefined" && value !== null && typeof value.value !== "undefined") 
        {
            this.setState({ 
                nostroBankAccountId: value !== null ? value.value : 0 
            });
        }
    }

    handleClearClick(event) {
        let currencyID = '';
        let systemDate = '';
        let amountA = 0;

        if(this.props.buyCurrency !== undefined)
        {
            currencyID = this.props.buyCurrency;
        }

        if(this.props.totalDue !== undefined)
        {
            amountA = this.props.totalDue;
        }

        systemDate = localStorage.getItem(GlobalSystemParametersNames.SystemDate);

        this.getOrdersForSettlements_intern(0, '', 0);

        this.setState({
            settlementID: 0,
            currencyID: currencyID,
            amount: amountA,
            dateReceived: systemDate,
            settlementStatus: 'Outstanding',
            settlementInstrument: '',
            settlementReferenceNo: '',
            updateToken: 0,
            chequeNumber: '',
            chequeBankId: 0,
            chequeDate: '',
            nostroBankAccountId: 0,
            listToApplyView: [],
            listToApply: [],
            validations: {
                ...this.state.validations,
                currencyId: true,
                amount: true,
                dateReceived: true,
                settlementInstrument: true,
                deliveryMethod: true,
                customerBankAccountId: true,
                nostroAccountId: true
            },
        })
    }

    voidSettlement = () => {
        getParametersByName(GlobalSystemParametersNames.LastClosingDate).then(
            (response) => {
                if (typeof response !== "undefined" && typeof response.parameters !== "undefined" && response.parameters.length > 0) {
                    
                    let currentSessionLastClosingDate = response.parameters[0].Value;
                    if (new Date(currentSessionLastClosingDate) > new Date(this.state.sessionLastClosingDate)) {
                        this.setState({ showAlert: true, alertMessage: 'You should restart the session. The application date is not correct.', alertTitle: 'Error' });
                        return false;
                    }

                    this.setState({ showVoidSettlementAlert: true }); 
                }
            }
        )
    }

    closeAlert = () => {
        this.setState({
            showAlert: false,
            saveInPendingStatus: false
        });
    }

    closeAlertSave = () => {
        this.setState({ showAlertSave: false });
    }

    yesApplySettlementsAlert() {
        this.setState({ showApplySettlementsAlert: false });
        let userID = localStorage.getItem('UserID');
        let newListToApply = [];

        this.state.listToApply.forEach(element => {
            if (element.OrderNo > 0) { 
                if (element.RecordID === this.state.currentElementToApply["Settlement ID"]) {
                    newListToApply.push({ ...element, RecordID: element.OrderNo });
                }
            } else {
                if (element.RecordID === this.state.currentElementToApply.RecordID) {
                    newListToApply.push(element);
                }
            }
        });

        var model = {
            SettlementID: this.state.settlementID,
            SettlementUpdateToken: this.state.updateToken,
            UserId: userID,
            Records: newListToApply
        }
        this.generalApply(model);
    }

    generalApply = (model) => {
        applySettlement(model).then(async (response) => {
            switch (Number(response.httpStatusCode)) {
                case 200:
                    this.setState({
                        listSettlementsToApply: [],
                        listToApply: [],
                        showAlert: true,
                        alertTitle: 'Success',
                        alertMessage: 'Settlement applied successfully.',
                    });
                    this.loadSettlementsForCustomer(this.state.customerID, true);
                    this.loadSettlement(this.state.settlementID, false, false)
                    this.getOrdersForSettlements_intern(this.state.customerID, this.state.currencyID, 0);

                    //Update order
                    if (this.props.reloadOrderInfo !== undefined) {
                        this.props.reloadOrderInfo();
                    }
                    break;
                case 409:
                    this.setState({
                        showAlert: true,
                        alertTitle: 'Error',
                        alertMessage: 'Current record has been updated by other user. Please refresh the information and try again.',
                    });
                    break;
                default:
                    this.setState({
                        showAlert: true,
                        alertTitle: 'Error',
                        alertMessage: 'An error occurred while trying to apply settlement. Please try again.',
                    });
                    break;
            }
        })
    }
    
    noApplySettlementsAlert() {
        this.setState({ showApplySettlementsAlert: false });
    }

    yesApplyCurentSettlementsAlert = () => {
        this.setState({ showApplyCurrentSettlementsAlert: false });

        let userID = localStorage.getItem('UserID');
        let newListToApply = [];

        this.state.listToApply.forEach(element => {
            if (element.OrderNo > 0) { 
                if (element.RecordID === this.state.currentElementToApply["Settlement ID"]) {
                    newListToApply.push({ ...element, RecordID: element.OrderNo });
                }
            } else {
                if (element.RecordID === this.state.currentElementToApply.RecordID) {
                    newListToApply.push(element);
                }
            }
        })
        
        var model = {
            SettlementID           : this.state.settlementID,
            SettlementUpdateToken  : this.state.updateToken,
            UserId              : userID,
            Records             : newListToApply
        }

        this.generalApply(model);
    }
    
    noApplyCurrentSettlementsAlert = () =>
    {
        this.setState({ 
            showApplyCurrentSettlementsAlert   : false,
            currentElementToApply           : null 
        });
    }

    handleSaveClickAskConfirmation = (event, saveInPendingStatus) => {
        event.preventDefault();
        this.setState({
            saveInPendingStatus: saveInPendingStatus
        }, () => {
            if (this.validateRequiredFields()) {
                //IsValidApplicationDate?
                getParametersByName(GlobalSystemParametersNames.LastClosingDate).then(
                    (response) => {
                        if (typeof response !== "undefined" && typeof response.parameters !== "undefined" && response.parameters.length > 0){
                            let currentSessionLastClosingDate = response.parameters[0].Value;
                            if (new Date(currentSessionLastClosingDate) > new Date(this.state.sessionLastClosingDate)) {
                                this.setState({ showAlert: true, alertMessage: 'You should restart the session. The application date is not correct.', alertTitle: 'Error' });
                                return false
                            }

                            let showChequeValidationMessage = false;
                            if (this.state.settlementInstrument === 'Cheque') {
                                if (typeof this.state.chequeDate !== "undefined" || this.state.chequeDate !== '') {
                                    let chequeDate = new Date(this.state.chequeDate);
                                    let systemDate = new Date(this.state.systemDate);
                                    if (chequeDate > systemDate) {
                                        showChequeValidationMessage = true;
                                    }
                                }
                            }

                            var settlementconfirmMessage = "Are you sure you want to save the amount of " + formatToCurrencyWithScale(this.state.amount, this.state.currencyID) + " " +
                                                            this.state.currencyID + " for this settlement from customer " + this.state.customerID + "?";
                            
                            if(this.state.amount > this.props.totalDue){
                                settlementconfirmMessage = "An incoming settlement of " + formatToCurrencyWithScale(this.state.amount, this.state.currencyID) + " " + this.state.currencyID +
                                " will be created to reflect the TOTAL amount sent by the customer. An amount of "+ formatToCurrencyWithScale(this.props.totalDue, this.state.currencyID) + " " + this.state.currencyID +" will be applied to this order.";
                            }

                            /*if(this.state.relatedDealID > 0){
                                settlementconfirmMessage += ' Please notice that this settlement will be applied to order ' + this.state.relatedDealID + '.';
                            }*/

                            if (showChequeValidationMessage) {
                                settlementconfirmMessage = 'Please note this is a post dated cheque. ' + settlementconfirmMessage
                            }
                            
                            var similarSettlementMessage;
                            if(this.state.settlementID === 0){
                                var similarSettlement = this.state.listCustomerSettlements.find((settlement) => { return Number(settlement.Amount) === Number(this.state.amount);});
                                if(similarSettlement !== undefined){
                                    similarSettlementMessage = ' Please notice there is an ' + similarSettlement.Status +  ' settlement with the same amount.';
                                    settlementconfirmMessage += similarSettlementMessage;
                                }
                            }

                            if (saveInPendingStatus) {
                                this.saveSettlement();
                            } else if(similarSettlementMessage !== undefined) {
                                this.setState({
                                    showAlertSave: true,
                                    alertMessageSave: settlementconfirmMessage
                                })
                            } else {
                                this.saveSettlement();
                            }
                        }
                    }
                )
            }
        })
    }

    validateRequiredFields() {
        var valid = true;

        var vCurrencyId = true,
            vAmount = true,
            vSettlementInstrument = true,
            vDeliveryMethod = true,
            vDateReceived = true,
            vCustomerBankAccountId = true,
            vNostroAccountId = true,
            vChequeNumber = true,
            vChequeDate = true,
            vChequeBankId = true;

        if (this.state.amount == null || Number(this.state.amount) <= Number(0)) {
            vAmount = false;
        }

        if (this.state.currencyID == null || this.state.currencyID === '') {
            vCurrencyId = false;
        }

        if (this.state.dateReceived == null || this.state.dateReceived === '') {
            vDateReceived = false;
        }

        if (this.state.settlementInstrument == null || this.state.settlementInstrument === '' || this.state.settlementInstrument.includes('Select')) {
            vSettlementInstrument = false;
        }
        
        var validateDeliverMethod = false;
        if (this.state.listDeliveryMethods[this.state.settlementInstrument] !== undefined) {
                validateDeliverMethod = true;
        }

        if (validateDeliverMethod &&
            (this.state.deliveryMethod == null || this.state.deliveryMethod === '' || this.state.deliveryMethod.includes('Select'))) {
            vDeliveryMethod = false;
        }

        var validateCustomerBankAccountId = (this.state.settlementInstrument === 'Direct Debit');
        if (validateCustomerBankAccountId &&
            (this.state.customerBankAccountId == null || this.state.customerBankAccountId === '')) {
            vCustomerBankAccountId = false;
        }

        if (Number(this.state.nostroBankAccountId) === 0) {
            vNostroAccountId = false;
        }

        if(!this.hideChequeInfo()) {
            if(this.state.chequeNumber == null || this.state.chequeNumber === '' ){
                vChequeNumber = false;
            }
            if(this.state.chequeDate == null || this.state.chequeDate === '' ){
                vChequeDate = false;
            }
            if (Number(this.state.chequeBankId) === 0) {
                vChequeBankId = false;
            }
        }
        
        valid = vCurrencyId && vAmount && vSettlementInstrument && vDeliveryMethod && vDateReceived && vCustomerBankAccountId && vNostroAccountId
                && vChequeNumber && vChequeDate && vChequeBankId;

        this.setState({
            validations: {
                ...this.state.validations,
                currencyId: vCurrencyId,
                amount: vAmount,
                settlementInstrument: vSettlementInstrument,
                deliveryMethod: vDeliveryMethod,
                dateReceived: vDateReceived,
                customerBankAccountId: vCustomerBankAccountId,
                nostroAccountId: vNostroAccountId,
                chequeNumber: vChequeNumber,
                chequeDate: vChequeDate,
                chequeBankId: vChequeBankId
            }
        })
        return valid;
    }

    handleShowLinkedSettlementUpdate = (event) => {
        let checked = event.target.checked;
        this.setState({showLinkedSettlements: checked});
    }

    //actions
    handleRowClick(row) {        
        this.handleClearClick();
        this.loadSettlement(row['Settlement ID'], false, false);
    }

    handleAppliesSettlementRowClick = (settlementId) => {        
        if (settlementId !== null && settlementId > 0) {
            this.loadSettlement(settlementId, false, false);
        }
    }

    handleUnlinkSettlement = (rowElement) => {
        let canBeVoided = rowElement.CanBeVoided;
        if (canBeVoided) {
            let message = "Are you sure you want to unapply this settlement?"
            let systemDate = localStorage.getItem(GlobalSystemParametersNames.SystemDate);
            
            this.setState({
                messageUnapplied: message,
                settlementElementToUnapply: true,
                settlementElementToUnapply: rowElement,
            });
        } else {
            this.setState({
                alertTitle: 'Error',
                alertMessage: 'This settlement application cannot be voided. Please contact administrator.',
                showAlert: true,
            })
        }
    }

    handleAmountToUse2 = (data, amountToUse) => {
        if (data.status === 'Fully Applied') {
            return
        }
        let valid = true;
        let settlementChanged = this.state.listCustomerSettlements.filter(item => item['Settlement ID'] === data.recordID)[0]
        
        if (settlementChanged === undefined) {
            return
        }
        
        let order = this.props.orderInfo;
        let totalDue = order.TotalOrder + order.TotalFees - order.TotalPaidByCustomer;
        totalDue = roundAmountByCurrency(totalDue, this.state.currencyID);
        let tempToApply = this.state.listToApply;

        if (amountToUse < 0) {
            this.setState({ showAlert: true, alertMessage: 'Amount to Use should be a positive decimal', alertTitle: 'Error' });
            settlementChanged['AmountToUse'] = 0;
            valid = false;
        } else if (amountToUse > data.pendingAmount) {
            this.setState({ showAlert: true, alertMessage: 'Amount to Use should be less than OutStanding Balance.', alertTitle: 'Error' });
            settlementChanged['AmountToUse'] = 0;
            valid = false;
        } else if (amountToUse > totalDue) {
            this.setState({ showAlert: true, alertMessage: 'Amount to Use should be less than Due Amount: ' + formatToCurrencyWithScale(totalDue, this.state.currencyID) });
            settlementChanged['AmountToUse'] = 0;
            valid = false;
        } else if (tempToApply.length > 0) {
            let amountTotalToApply = tempToApply.map(item => item.AmountToUse).reduce((prev, next) => prev + next);
            if (amountTotalToApply > data.pendingAmount) {
                this.setState({ showAlert: true, alertMessage: 'Amount to Use should be less than Balance', alertTitle: 'Error' });
                settlementChanged['AmountToUse'] = 0;
                valid = false;
            }
        }
        
        //remove if exist
        if (tempToApply.length > 0) {
            tempToApply = tempToApply.filter(item => item.RecordID !== data.recordID)
        }
        
        if (valid && amountToUse > 0) {
            //add if amount > 0
            if (amountToUse > 0) {
                tempToApply.push({
                    RecordID: data.recordID,
                    OrderNo: this.props.orderNo,
                    AmountToUse: amountToUse,
                    OrderUpdateToken: data.orderUpdateToken,
                });
            }
            settlementChanged['AmountToUse'] = amountToUse;
        }        
        this.setState({ listToApply: tempToApply }, () => this.updateCombinedBalance(tempToApply));
    }

    updateCombinedBalance = (list) => {
        let actualCombinated = this.state.saveAmountCombined;
        var amount = 0;
        list.forEach(element => {
            if (element.AmountToUse > 0) {
                amount += element.AmountToUse
            }
        });
        this.setState({ combinedBalance: actualCombinated - amount });
    }

    handleNewAppy = (element, index) => {
        if(element.AmountToUse !== undefined && element.AmountToUse !== null && element.AmountToUse !== 0){
            this.setState({ 
                showApplyCurrentSettlementsAlert   : true,
                currentElementToApply           : element,
                confirmCurrentElementMessage    : "You will apply: " + formatToCurrencyWithScale(element.AmountToUse, this.state.currencyID) + ' ' + this.state.currencyID
            });

        } else {
            let auxValdiation       = this.state.validations.inputAmountList;
            auxValdiation[index]    = false;
            this.setState({
                validations: {...this.state.validations, inputAmountList: auxValdiation}
            });
        }
    }

    handleAmountToUse(data, i, event) {
        debugger;
        if (this.state.listToApplyView === undefined) {
            return
        }
        
        let tempToApply = this.state.listToApply;
        let value = event.target.value;
        value = value.toString().replace(',','');
        let amountToUse = Number(value);       
        let settlementChanged = this.state.listToApplyView.filter(item => item['RecordID'] === data.recordID)[0]
        if (settlementChanged === undefined) {
            return
        }
        let valid = true;
        let auxValdiation = this.state.validations.inputAmountList;
        
        if (amountToUse < 0) {
            this.setState({ showAlert: true, alertMessage: 'Amount to Use should be a positive decimal', alertTitle: 'Error' });
            settlementChanged['AmountToUse'] = 0;
            valid = false;
        }
        if (amountToUse > data.pendingAmount) {
            this.setState({ showAlert: true, alertMessage: 'Amount to Use should be less than Pending Amount', alertTitle: 'Error' });
            settlementChanged['AmountToUse'] = 0;
            valid = false;
        }
        let incomingSettlementFormAmount = this.state.amount
        if (this.state.selectedSettlement !== undefined && this.state.selectedSettlement != null
            && this.state.selectedSettlement.Status === 'Fully Applied' && this.state.selectedSettlement.Amount > 0) {
            incomingSettlementFormAmount = this.state.selectedSettlement.Amount
        }
        if (amountToUse > incomingSettlementFormAmount) {
            this.setState({ showAlert: true, alertMessage: 'Amount to Use should be less than Settlement Amount', alertTitle: 'Error' });
            settlementChanged['AmountToUse'] = 0;
            valid = false;
        }
        if (tempToApply.length > 0) {
            let amountTotalToApply = tempToApply.map(item => item.AmountToUse).reduce((prev, next) => prev + next);
            if (amountTotalToApply > this.state.outstandingBalance) {
                this.setState({ showAlert: true, alertMessage: 'Amount to Use should be less than Balance', alertTitle: 'Error' });
                settlementChanged['AmountToUse'] = 0;
                valid = false;
            }
        }
        //remove if exist
        if (tempToApply.length > 0) {
            tempToApply = tempToApply.filter(item => item.RecordID !== data.recordID)
        }

        if (valid /*&& amountToUse > 0*/) {
            //add if amount > 0
            //if (amountToUse > 0) {
                tempToApply.push({
                    RecordID: data.recordID,
                    AmountToUse: (amountToUse === undefined || amountToUse === null || amountToUse === '') ? 0 : amountToUse,
                    OrderUpdateToken: data.orderUpdateToken,
                });
            //}
            settlementChanged['AmountToUse'] = amountToUse;
            auxValdiation[i] = true;
        }
                   
        this.setState({
            listToApply: tempToApply,
            validations: { ...this.state.validations, inputAmountList: auxValdiation }
        }, () => this.updateCombinedBalance(tempToApply));
    }

    handleFocusAmountApplied = (element, i, event) => {}

    changePage(value) {
        this.setState({
            currentPage: value
        }, () => {
            this.loadSettlementsForCustomer(this.state.customerID, false);
        });
    }

    //alerts
    handleApplySettlement = () => {
        this.setState({ showApplySettlementsAlert: true });
    }

    handleUnlinkSettlement = (rowElement) => {
        let canBeVoided = rowElement.CanBeVoided;
        if (canBeVoided) {
            let message = "Are you sure you want to unapply this settlement?"
            let systemDate = localStorage.getItem(GlobalSystemParametersNames.SystemDate);
            if(this.props.orderInfo !== undefined && this.props.orderInfo.ValueDate < systemDate)
            {
                message = "Are you sure you want to unapply the settlement to the order with Value Date " + this.props.orderInfo.ValueDate+"?"
            }
            
            this.setState({
                messageUnapplied: message,
                showUnapplySettlementAlert: true,
                settlementElementToUnapply: rowElement,
            });
        } else {            
            this.setState({
                alertTitle: 'Error',
                alertMessage: 'This settlement application cannot be voided. Please contact administrator.',
                showAlert: true,
            })
        }
    }

    yesVoidSettlement = () => {
        this.setState({ showVoidSettlementAlert: false });
        var request = {
            SettlementID: this.state.settlementID,
            UserID: localStorage.getItem('UserID'),
            UpdateToken: this.state.updateToken
        }
        voidSettlement(request).then((response) => {
            var alertTitle = '';
            var alertMessage = '';

            switch (Number(response.httpStatusCode)){
                case 200:
                    this.handleClearClick();
                    this.loadSettlementsForCustomer(this.state.customerID, true);
                    this.loadSettlement(this.state.settlementID, false, false);
                    /*if (this.props.reloadDealHeaderInfo !== undefined) {
                        this.props.reloadDealHeaderInfo();
                    }*/
                    alertTitle = 'Success';
                    alertMessage = 'Settlement voided successfully';
                    break;
                case 400:
                    alertTitle = 'Error';
                    alertMessage = "An error occurred while trying to void the settlement. Please try again. (Bad Request)";
                    break;
                case 409:
                    alertTitle = 'Error';
                    alertMessage = 'Settlement has been updated by other user. Please reload the information and try again.';
                    if (response.httpErrorMessage !== undefined) {
                        alertMessage = response.httpErrorMessage;
                    }
                    break;
                default:
                    alertTitle = 'Error';
                    alertMessage = 'An error occurred while trying to void the settlement. Please try again.'
                    if (response.Message !== undefined) {
                        alertMessage = response.Message;
                    }
                    break;
            }
            this.setState({
                showAlert: true,
                alertMessage: alertMessage,
                alertTitle: alertTitle,
                loading: false,
            });
        })
    }
    
    yesUnapplySettlement = () => {
        this.setState({ showUnapplySettlementAlert: false });
        let userID = localStorage.getItem('UserID');
        var order = this.state.settlementElementToUnapply;
        var model = {
            SettlementApplicationID: order.SettlementApplicationID,
            BNOrderNo: order.RecordID,
            UpdateToken: order.OrderUpdateToken,
            UserID: userID,
            SettlementUpdateToken: this.state.updateToken,
        }
        unapplySettlement(model).then(async (response) => {
            switch (Number(response.httpStatusCode)) {
                case 200:
                    this.setState({
                        listSettlementsToApply: [],
                        listToApply: [],
                        showAlert: true,
                        alertTitle: 'Success',
                        alertMessage: 'Settlement unapplied successfully.'
                    });
                    this.loadSettlementsForCustomer(this.state.customerID, true);
                    this.loadSettlement(this.state.settlementID, false, false);
                    this.getOrdersForSettlements_intern(this.state.customerID, this.state.currencyID, this.setState.settlementID)
                    
                    //Update order
                    if (this.props.reloadOrderInfo !== undefined) {
                        this.props.reloadOrderInfo();
                    }
                    break;
                case 409:
                    this.setState({
                        showAlert: true,
                        alertTitle: 'Error',
                        alertMessage: 'Current record has been updated by other user. Please refresh the information and try again.',
                    });
                    break;
                default:
                    this.setState({
                        showAlert: true,
                        alertTitle: 'Error',
                        alertMessage: 'An error occurred while trying to unapply settlement. Please try again.',
                    });
                    break;
            }
        })
    }

    closeVoidSettlementAlert = () => {
        this.setState({ showVoidSettlementAlert: false });
    }
    
    closeUnaplySettlementAlert = () => {
        this.setState({ showUnapplySettlementAlert: false });
    }

    //functions
    loadBankAccountsByCurrency(customerId, currencyId) {
        let loadCustomerAccount = !this.state.thirdPartyBeneficiarySettlement;
        if (loadCustomerAccount) {
            getBankAccountsByCurrency(customerId, currencyId).then(
                (response) => {
                    if (typeof response !== "undefined" && typeof response.accounts !== "undefined") {
                        let bankAccounts = response.accounts;
                        bankAccounts.forEach(element => {
                            element.value = element.BankAccountID;
                            element.name = element.Description;
                        });

                        this.setState({ listCustomerBankAccounts: bankAccounts });
                    } else {
                        this.setState({ listCustomerBankAccounts: [] });
                    }
                }
            )
        }
    }

    async loadNostroBankAccounts(currencyID){
        if(currencyID !== '') {
            await getNostroBankAccountsForFunds(currencyID, this.state.customerID, false).then(
                async (response) => {
                    if (response != null && response.nostroBankAccounts != null) {
                        let nostroAccounts = response.nostroBankAccounts.map(ba => ({ ...ba, value: ba.BankAccountID, name: ba.BankName }));
                        await getVirtualBankAccountsByCurrencyID(this.state.customerID, currencyID).then(
                            (json) => {
                                if (json != null && json.virtualBankAccounts != null) {
                                    if (json.virtualBankAccounts.length > 0) {
                                        let virtualBankAccounts = json.virtualBankAccounts.map(ba => ({ ...ba, value: ba.BankAccountID, name: ba.BankName }));
                                        nostroAccounts = [...nostroAccounts, ...virtualBankAccounts];
                                    }
                                }
                            }
                        )
                        this.setState({
                            listNostroAccounts: nostroAccounts
                        });
                    } else {
                        this.setState({ listNostroAccounts: [] });
                    }
                }
            )
        }
    }

    async loadBeneficiaries() {
        await getBeneficiariesByCustomer(this.props.customerID, 0).then(
            (json) => {
                var helperForSettlement = [];

                if(json.beneficiaries !== undefined){                    
                    for(var i=0; i<json.beneficiaries.length; i++){
                        json.beneficiaries[i].value = json.beneficiaries[i].BeneficiaryID;
                        json.beneficiaries[i].name = json.beneficiaries[i].Description;

                        if(json.beneficiaries[i].PaymentFlow !== undefined)
                        {
                            if(json.beneficiaries[i].PaymentFlow !== 'Pays to' && json.beneficiaries[i].PaymentFlow !== null && json.beneficiaries[i].PaymentFlow !== '')
                            {
                                helperForSettlement.push(json.beneficiaries[i]);
                            }
                        }
                    }
                }
                
                this.setState({
                    listThirdPartyBenes: helperForSettlement,
                });
            }
        )
    }

    saveSettlement = async() => {
        this.setState({loading:true});
        let userID = localStorage.getItem('UserID');
        let settlementStatus = "Outstanding";
        if(this.state.saveInPendingStatus){ settlementStatus = "Outstanding"; }
        else { settlementStatus = "Unapplied"; }

        var model = {
            AmountReceived: this.state.amount,
            CurrencyID: this.state.currencyID,
            CustomerID: this.state.customerID,
            DateReceived: this.state.dateReceived,
            NostroBankAccountID: this.state.nostroBankAccountId !== null ? this.state.nostroBankAccountId : 0,
            SettlementID: this.state.settlementID,
            SettlementInstrument: this.state.settlementInstrument,
            SettlementMethod: this.state.deliveryMethod,
            Status: settlementStatus,
            TotalApplied: 0,
            UpdateToken: this.state.updateToken,
            UserID: userID,
            FundsFlow: this.props.lockedSide,
            ChequeNumber: this.state.chequeNumber,
            ChequeBankId: this.state.chequeBankId,
            ChequeDate: this.state.chequeDate,
            settlementReferenceNo: this.state.settlementReferenceNo
        }
        
        this.setState({ showAlertSave: false });

        saveSettlements(model).then(async (response) => {
            if (response.httpStatusCode === 400) {
                let httpStatusText = "An error occurred while trying to save the settlement. Please try again. (Bad Request)";
                this.setState({
                    showAlert: true,
                    alertMessage: httpStatusText,
                    alertTitle: 'Error',
                    saveInPendingStatus: false
                })
            } else if (response.httpStatusCode !== 200) {
                var alertMessage = 'An error occurred while trying to save the settlement. Please try again.'
                if (response.httpErrorMessage !== undefined && response.httpErrorMessage !== '') {
                    alertMessage = response.httpErrorMessage;
                }
                this.setState({
                    showAlert: true,
                    alertMessage: alertMessage,
                    alertTitle: 'Error',
                    saveInPendingStatus: false
                });
            } else {
                let settlementId = response.SettlementID

                if(this.props.orderInfo !== undefined && this.state.settlementID === 0) {} 

                this.loadSettlementsForCustomer(this.state.customerID, true)
                this.setState({
                    settlementID: settlementId,
                    showAlert: true,
                    alertTitle: 'Success',
                    alertMessage: 'Settlement successfully saved!',
                    saveInPendingStatus: false,
                    entityPropertiesSaveProcess: true,
                }, () => this.loadSettlement(settlementId, true, false));

                //Reload bnOrder
                if (this.props.reloadOrderInfo !== undefined) {
                    this.props.reloadOrderInfo();
                }
            }
        })

        this.setState({loading:false});
    }

    getSettlementsWithBalanceByCustomerAndCurrency(CustomerID, CurrencyID) {
        var balance = 0;
        getSettlementsWithBalanceByCustomerCurrency(CustomerID, CurrencyID, this.props.lockedSide).then(
            (json) => {
                if (json !== undefined && json.settlements !== undefined) {
                    for (var i = 0; i < json.settlements.length; i++) {
                        balance += json.settlements[i].AmountReceived - json.settlements[i].TotalApplied;
                    }
                }
                this.setState({ customerSettlementsBalance: balance });
            }
        )
    }

    loadListOfBanks() {
        getListOfBanks(true).then(
            (response) => {
                if (typeof response !== "undefined" && response.banks !== "undefined"){
                    let banks = response.banks;
                    banks.forEach(element => {
                        element.value = element.BankID;
                        element.name = element.Name;
                    });
                    this.setState({ listBanks: response.banks })
                } else {
                    this.setState({ listBanks: [] })
                }
            }
        )
    }

    hideChequeInfo() {
        if (this.state.settlementInstrument === 'Cheque') {
            return false
        } else {
            return true
        }
    }
    
    hideSaveInPendingButton() {
        if (this.state.settlementID === 0) {
            return false
        } else if (this.state.settlementID > 0 && ['Unapplied'].includes(this.state.settlementStatus)){
            return false
        } else {
            return true
        }
    }

    hideConfirmButton() {
        if(this.state.settlementID > 0 && ['Fully Applied', 'Partially Applied', 'Voided'].includes(this.state.settlementStatus)){
            return true
        } else {
            return false
        }
    }

    hideVoidButton() {
        if (this.state.settlementID !== "undefined" && this.state.settlementID > 0) {
            return false
        } else {
            return true
        }
    }

    onFinishEntityPropertiesSaveProcess(){
        this.setState({entityPropertiesSaveProcess: false});
    }

    //validations
    formatValidSelect(valid) {
        return valid ? regularSelectClass : notFilledSelectClass;
    }

    formatValidInput(valid) {
        return valid ? regularInputClass : notFilledInputClass;
    }

    sortData(col) {
        let newDirection = "asc";        
        if (this.state.column === col && this.state.direction === "asc") {
          newDirection = "desc";
        }

        let data = this.state.listToApplyView;    
        const sorted = [...data].sort((a, b) => {
          if (a[col] < b[col]) return newDirection === "asc" ? -1 : 1;
          if (a[col] > b[col]) return newDirection === "asc" ? 1 : -1;
          return 0;
        });
        this.setState({listToApplyView: sorted, column: col, direction: newDirection});
      };

    calculateBalance() {
        let paymentBalance = this.state.outstandingBalance;

        this.setState({
            currentSettlementBal: paymentBalance
        });
    }

    render(){
        let orderUpdateToken = this.props.orderInfo !== undefined ? this.props.orderInfo.UpdateToken : 0

        let headerMessage = [];
        if (this.state.settlementID > 0) {
            headerMessage.push('Status: ' + this.state.settlementStatus)
        }
        let saveButtonText = "Confirm";
        if (this.state.settlementStatus === "Outstanding") {
            saveButtonText = "Confirm"
        }

        var mainTitle = "";
        if (this.props.mainTitle != null) {
            mainTitle = ""
        } else if (this.props.backLink != null && this.props.settlementOpenFromBoard != null) {
            mainTitle = (
                <h3 className="uk-heading-divider" style={style.titleStyle}>
                        <button className="uk-button uk-button-text uk-margin-small-right min-width-0" onClick={this.handleBackLink.bind(this)}>
                            <i className="fa fa-arrow-left back-arrow-white"></i>
                        </button>
                        Settlement Information
                    </h3>
            )
        }
        
        let incomingSettlementFormAmount = this.state.amount
        if (this.state.selectedSettlement !== undefined && this.state.selectedSettlement != null
            && this.state.selectedSettlement.Status === 'Fully Applied' && this.state.selectedSettlement.Amount > 0) {
            incomingSettlementFormAmount = this.state.selectedSettlement.Amount
        }

        var disableIfFullyApplied = false;
        if (this.state.settlementStatus === 'Fully Applied') {
            disableIfFullyApplied = true;
        }
        
        var disableIfPartiallyApplied = false;
        if (this.state.settlementStatus !== '' && this.state.settlementStatus !== 'Outstanding' ) {
            disableIfPartiallyApplied = true;
        }

        let disableIfFromSettlements = false;
        /*if (this.state.fromSettlements) {
            disableIfFromSettlements = true;
        }*/

        //Amount control
        var amountControlDisable = false;
        if ((this.state.disbursedAmount > 0 || this.state.refundedAmount > 0)
            && this.state.settlementStatus !== 'Outstanding') {
            amountControlDisable = true;
        }

        //Currency control
        var currencyControlDisabled = false;
        if (this.state.settlementID > 0 || this.props.buyCurrency !== undefined) {
            currencyControlDisabled = true;
        }
        
        //Delivery methods
        var deliveryMethods = [];
        if (this.state.listDeliveryMethods[this.state.settlementInstrument] !== undefined) {
            deliveryMethods = this.state.listDeliveryMethods[this.state.settlementInstrument];
        }

        var headers;
        var rows = [];

        headers = (
            <tr style={{textAlignLast: 'center'}}>
                <th onClick={() => this.sortData("RecordNo")}>Order ID</th>
                <th onClick={() => this.sortData("SettlementCurrencyID")}>Currency</th>
                <th onClick={() => this.sortData("TotalOrder")}>Total Order Amount</th>
                {/*<th>Complete Amount</th>*/}
                <th onClick={() => this.sortData("PendingAmount")}>Pending Amount</th>
                {/*<th>Order ID</th>*/}
                <th onClick={() => this.sortData("Status")}>Settlement Status</th>
                <th>Amount To Use</th>                
                {!this.state.readOnly && <th>Actions</th>}
            </tr>
        )

        var index = 0;
        if (this.state.listToApplyView !== undefined) {
            this.state.listToApplyView.forEach((element,i) => {
                index++;
                var voidAction;
                var amountControl;
                
                if(this.state.settlementStatus === 'Unapplied' || this.state.settlementStatus === 'Partially Applied') {
                    voidAction = (
                        <i
                            className="fa fa-money" 
                            onClick={() => this.handleNewAppy(element, i)} 
                            style={{ 
                                fontSize        : '1.25em', 
                                verticalAlign   : 'middle', 
                                cursor          : 'pointer', 
                                paddingLeft     : '10px', 
                                paddingRight    : '10px'
                            }}
                            title={'Apply'}
                        />
                    )
                }
                if (Number(element.SettlementApplicationID) > 0) {
                    voidAction = (
                        <i 
                            className   = "fa fa-chain-broken" 
                            onClick     = {() => this.handleUnlinkSettlement(element)} 
                            style       = {{ 
                                fontSize        : '1.75em', 
                                verticalAlign   : 'middle' 
                            }}
                            title={'Unapply'}
                        />
                    );
                    amountControl = (formatToCurrencyWithScale(element['AmountToUse'], this.state.currencyID));                    
                } else {
                    amountControl = (
                        <NumberInput  id={'settlement-amount-to-use-' + index}
                            type        = "Currency"
                            value       = {element['AmountToUse']}
                            className= {this.state.validations.inputAmountList[i] ? 'uk-input' : ' uk-input uk-form-danger'}
                            disabled    = {this.state.readOnly}
                            onChange    = {this.handleAmountToUse.bind(this,
                                {
                                    recordID: element['RecordID'],
                                    pendingAmount: element['PendingAmount'],
                                    amount: element['TotalOrder'],
                                    orderUpdateToken: element['OrderUpdateToken'],
                                }, i)}
                            onFocus={(event) => this.handleFocusAmountApplied(element,i , event)}
                        />
                    )
                }

                rows.push(
                    <tr key={index} /*onClick={() => this.handleAppliesSettlementRowClick(element['RecordNo'])}*/ >
                        <td style={{textAlign: 'center'}}>{element['RecordNo']}</td>
                        <td style={{textAlign: 'center'}}>{element['SettlementCurrencyID']}</td>
                        <td style={{textAlign: 'right'}}>{formatToCurrencyWithScale(element['TotalOrder'], this.state.currencyID)}</td>
                        <td style={{textAlign: 'right'}}>{formatToCurrencyWithScale(element['PendingAmount'], this.state.currencyID)}</td>
                        <td style={{textAlign: 'center'}}>{element['Status']}</td>
                        <td style={{textAlign: 'right'}}>
                            {amountControl}
                        </td>   
                        {!this.state.readOnly && 
                            <td 
                                style = {{
                                    textAlign       : "center",
                                    verticalAlign   : 'middle'
                                }}
                            >
                                {voidAction}
                            </td>
                        }
                    </tr>
                )
            })
        }

        //list of settlements to be applied
        var amountTotalToApply = 0;
        var numberOfRecordsToApply = 0;
        this.state.listToApply.forEach(element => {
            amountTotalToApply += element.AmountToUse;
            numberOfRecordsToApply++;
        });

        var validToApply = false;
        if (this.state.settlementStatus === "Unapplied" ||
            this.state.settlementStatus === "Partially Applied") {
            if (numberOfRecordsToApply > 0) {
                validToApply = true;
            }
        }

        let additionalPropertiesSection = []
        additionalPropertiesSection.push(<li className="">
            <h5 className="uk-accordion-title">Additional Properties</h5>
            <div className="uk-accordion-content" style={{ backgroundColor: '#f8f8f8' }} >
                <div id="settlement-application-form-additional-properties">
                    <EntityProperties id="settelement-application-form" 
                        entityType={SettlementType}
                        entityID={this.state.settlementID}
                        fullScreen={true} 
                        runSaveProcess={this.state.entityPropertiesSaveProcess}
                        finishSaveProcess={this.onFinishEntityPropertiesSaveProcess.bind(this)}
                        readOnly={this.state.readOnly}/>
                </div>
            </div>
        </li>)

        let listCustomerSettlementsFiltered = this.state.listCustomerSettlements;
        let settlementsFoundingSection = []
        if (this.props.orderNo > 0) {
            settlementsFoundingSection.push(<SettlementsApplied
                rowClick={this.handleAppliesSettlementRowClick}
                unlinkSettlement={this.handleUnlinkSettlement}
                orderUpdateToken={orderUpdateToken}
                readOnly={this.state.readOnly}
            />)
            settlementsFoundingSection.push(<SettlementsNotApplied
                settlements={(this.state.listCustomerSettlements || []).filter(x => ['Unapplied', 'Partially Applied'].includes(x.Status))}
                rowClick={this.handleAppliesSettlementRowClick}
                handleAmountToUse={this.handleAmountToUse2}
                handleNewAppy={this.handleNewAppy}
                orderNo={this.props.orderNo}
                selectedSettlementId={this.state.settlementID}
                orderUpdateToken={orderUpdateToken}
                readOnly={this.state.readOnly}
                currencyId={this.state.currencyID}
            />)
            if (listCustomerSettlementsFiltered !== undefined) {
                listCustomerSettlementsFiltered = listCustomerSettlementsFiltered.filter(x => !['Fully Applied', 'Unapplied', 'Partially Applied'].includes(x.Status))
            }
        }

        let settlementApplication = []
        let settlementApplicationSection = !(this.props.orderNo > 0)
        if (settlementApplicationSection) {
            settlementApplication.push(<li className="uk-open">
                <h5 className="uk-accordion-title" >Settlement application</h5>
                <div className="uk-accordion-content" style={{ backgroundColor: '#f8f8f8' }}>
                    <div id="settlement-application">
                        <div className="uk-width-1-1" id="settlements-apply-component">
                            <div className="uk-grid uk-margin">
                                <div className="uk-width-1-2">
                                    <label className="uk-form-label">Customer Settlements Balance: {formatToCurrencyWithScale(this.state.customerSettlementsBalance, this.state.currencyID)} {this.state.currencyID}</label>
                                </div>
                                <div className="uk-width-1-2">
                                    <label className="uk-form-label uk-align-right">Combined Balance: {(this.state.combinedBalance)}</label>
                                </div>

                                <div className="uk-width-1-1">
                                    <label className="uk-form-label uk-align-right">(Current Settlement Bal: {formatToCurrencyWithScale(this.state.currentSettlementBal, this.state.currencyID)})</label>
                                </div>
                            </div>
                            <div className="uk-width-1-1 border-table">
                                <table className="uk-table uk-table-striped uk-table-hover uk-table-divider" hidden={rows.length === 0}>
                                    <thead>
                                        {headers}
                                    </thead>
                                    <tbody>
                                        {rows}
                                    </tbody>
                                </table>
                            </div>
                            <h5 style={style.alignCenter} hidden={rows.length > 0}>No records found.</h5>
                        </div>
                    </div>
                </div>
            </li>)
        }

        let availableSettlementsSection = [];
        availableSettlementsSection.push(<li className="uk-open">
            <h5 className="uk-accordion-title">Available settlements</h5>
            <div className="uk-accordion-content" style={{ backgroundColor: '#f8f8f8' }}>
                <div id="available-settlements">
                    <div className="uk-width-1-1" id="settlements-component">
                        <div className="uk-grid uk-margin uk-form-controls">
                            <div className="uk-width-1-4">
                                <label>
                                    <input className="uk-checkbox" type="checkbox" checked={this.state.showLinkedSettlements} onChange={this.handleShowLinkedSettlementUpdate}/> Show linked settlements
                                </label>
                            </div>
                        </div>

                        <NewDynamicTable id="alert-settlementapplicationform-table" 
                            data={listCustomerSettlementsFiltered}
                            enableClick={true}
                            clickFunction={this.handleRowClick.bind(this)}
                            hiddenHeaders={[]}
                            hidden={this.props.settlementOpenFromBoard}
                            enableSortByHeader={true}
                            newSearch={this.state.newSearch}
                            formats={[{ header: 'Amount', formatFunction: formatToCurrencyWithScale, formatCurrency:'Currency ID' },
                                { header: 'Outstanding Balance', formatFunction: formatToCurrencyWithScale, formatCurrency:'Currency ID' }]}
                        />

                        <Paginator id="alert-settlementapplicationform-paginator" changePage={this.changePage.bind(this)} numberOfPages={this.state.totalPages} newSearch={this.state.newSearch} />
                    </div>
                </div>
            </div>
        </li>)

        var additionalInfo = <ul id="accordion-compliance" uk-accordion="multiple: true" >
                {settlementsFoundingSection}

                {settlementApplication}

                {/*{availableSettlementsSection}

                {additionalPropertiesSection}*/}
            </ul>

        var regularScreen = (
            <div>
                {mainTitle}
                <div className="uk-grid uk-margin">
                    <div className="uk-width-1-4">
                        <label className="uk-form-label">Settlement amount</label>
                        {!this.state.readOnly ?
                            <NumberInput id="form-settlementapplicationform-amount"
                                className={this.formatValidInput(this.state.validations.amount)}
                                type="Currency"
                                value={incomingSettlementFormAmount}
                                placeholder="Please input the TOTAL amount sent by the customer."
                                scale={getScaleByCurrency(this.state.currencyID)}
                                onChange={this.getAmountValue.bind(this)}
                                disabled={amountControlDisable || disableIfFullyApplied || disableIfFromSettlements || disableIfPartiallyApplied}/>
                            :
                            <p id="label-settlementapplicationform-amount" style={{marginTop: '5px'}}>
                                {formatToCurrencyWithScale(this.state.amount, this.state.currencyID )}
                            </p>
                        }
                    </div>
                    <div className="uk-width-1-4">
                        <label className="uk-form-label">Currency</label>
                        {!this.state.readOnly ?
                            <DynamicSelect id="form-settlementapplicationform-currency"
                                className={this.formatValidSelect(this.state.validations.currencyId)}
                                placeholder='Select a currency'
                                placeholderValue=''
                                data={this.state.listActiveCurrencies}
                                objValue={{ value: this.state.currencyID }}
                                getValue={this.handleCurrencyUpdate}
                                disabled={/*currencyControlDisabled ||*/ disableIfFullyApplied || disableIfFromSettlements || disableIfPartiallyApplied}/>
                            :
                            <p id="label-settlementapplicationform-currency" style={{marginTop: '5px'}}>
                                {this.state.currencyID !== "" && this.state.listActiveCurrencies.length > 0 ?
                                    this.state.listActiveCurrencies.find(c => c.CurrencyID === this.state.currencyID).name : "-"}
                            </p>
                        }
                    </div>

                    <div className="uk-width-1-2">
                        <div style={{ textAlign: "right" }}>
                            <h4>{headerMessage}</h4>
                        </div>
                        <div></div>
                    </div>

                    <div className="uk-width-1-4" style={{ marginTop: 7 }}>
                        <label className="uk-form-label">Settlement Instrument</label>
                        {!this.state.readOnly ?
                            <DynamicSelect id="form-settlementapplicationform-settlementintrument"
                                className={this.formatValidSelect(this.state.validations.settlementInstrument)}
                                data={this.state.listIncomingInstruments}
                                objValue={{ value: this.state.settlementInstrument }}
                                placeholder="Select an Instrument..."
                                getValue={this.handleIncomingInstrument} 
                                disabled={disableIfFullyApplied}/>
                            :
                            <p id="label-settlementapplicationform-settlementintrument" style={{marginTop: '5px'}}>
                                {this.state.settlementInstrument !== "" ?this.state.settlementInstrument : "-"}
                            </p>
                        }
                    </div>
                    <div className="uk-width-1-3 uk-background-muted uk-margin-top uk-padding-small uk-padding-remove-top uk-padding-remove-bottom"
                        style={{ borderWidth: 1, borderColor: 'lightgrey', borderStyle: 'solid', borderRightWidth: 0, borderBottomWidth: 0 , marginLeft: "40px"}} >
                        <div className="uk-form-controls" style={{ paddingTop: '0.5em' }} hidden={true}>
                            <input className="uk-checkbox" type="checkbox" disabled={this.state.readOnly || disableIfFullyApplied} id="form-settlementapplicationform-thirdPartyBeneficiarySettlement" checked={this.state.thirdPartyBeneficiarySettlement}
                                onChange={this.handleOnCheckThirdPartyBeneficiarySettlement.bind(this)} />
                            <label className="uk-form-label">Third Party?</label>
                        </div>

                        <label className="uk-form-label" hidden={this.hideChequeInfo()}>Cheque number</label>
                        <div className="uk-form-controls" hidden={this.hideChequeInfo()}>
                            {!this.state.readOnly ?
                                <input className={this.formatValidInput(this.state.validations.chequeNumber)} type="text" id="form-settlementapplicationform-chequeNumber" value={this.state.chequeNumber}
                                    onChange={this.handleChequeNumber.bind(this)} hidden={this.hideChequeInfo()} disabled={disableIfFullyApplied}/>
                                :
                                <p id="label-settlementapplicationform-settlementintrument" style={{marginTop: '5px'}}>
                                    {this.state.chequeNumber != null && this.state.chequeNumber !== "" ?this.state.chequeNumber : "-"}
                                </p>
                            }
                        </div>
                        
                        <label className="uk-form-label" hidden={!this.state.showDirectDebitFields}> Customer bank account</label>
                        <div className="uk-form-controls" hidden={!this.state.showDirectDebitFields}>
                            {!this.state.readOnly ?
                                <DynamicSelect className={this.formatValidSelect(this.state.validations.customerBankAccountId)} id="form-settlementapplicationform-customerbankaccount" 
                                    placeholder='Select an Account...' 
                                    data={this.state.listCustomerBankAccounts}
                                    objValue={{ value: this.state.customerBankAccountId }}
                                    getValue={this.handleCustomerBankAccount.bind(this)}
                                    disabled={disableIfFullyApplied}
                                />
                                :
                                <p id="label-settlementapplicationform-beneficiaryId" style={{marginTop: '5px'}}>
                                    {this.state.customerBankAccountId > 0 && this.state.listCustomerBankAccounts.length > 0 ?
                                        this.state.listCustomerBankAccounts.find(n => n.value === this.state.customerBankAccountId).name : "-"}
                                </p>
                            }
                        </div>
                    </div>

                    <div className="uk-width-1-3 uk-background-muted uk-margin-top uk-padding-small uk-padding-remove-top uk-padding-remove-bottom"
                        style={{ borderWidth: 1, borderColor: 'lightgrey', borderStyle: 'solid', borderLeftWidth: 0, borderBottomWidth: 0}}>
                        <label className="uk-form-label" hidden={this.hideChequeInfo()}>Cheque issue date</label>
                        <div className="uk-form-controls" hidden={this.hideChequeInfo()}>
                            {!this.state.readOnly ?
                                <DatePicker className={regularInputClass} id="form-settlementapplicationform-chequeIssueDate" 
                                    value={this.state.chequeDate}
                                    onDayChange={this.handleChequeDate.bind(this)} endDate={this.state.endDate} disabled={disableIfFullyApplied}/>
                                :
                                <p id="label-settlementapplicationform-dateReceived" style={{marginTop: '5px'}}>
                                    {this.state.chequeDate !== "" ? formatDate(this.state.chequeDate) : "-"}
                                </p>
                            }
                        </div>
                    </div>

                    <div className="uk-width-1-4" style={{ marginTop: 7 }}>
                        <label className="uk-form-label">Delivery method</label>
                        {!this.state.readOnly ? 
                            <DynamicSelect  id="form-settlementapplicationform-deliverymethod"
                                className={this.formatValidSelect(this.state.validations.deliveryMethod)}
                                data={deliveryMethods}
                                objValue={{ value: this.state.deliveryMethod }}
                                placeholder="Select a Delivery Method..."
                                placeholderValue=""
                                getValue={this.handleDeliveryMethod} 
                                disabled={disableIfFullyApplied || disableIfFromSettlements}/>
                            :
                            <p id="label-settlementapplicationform-deliverymethod" style={{marginTop: '5px'}}>
                                {this.state.deliveryMethod != null && this.state.deliveryMethod !== "" ? this.state.deliveryMethod : "-"}
                            </p>
                        }
                    </div>

                    <div className="uk-width-2-3 uk-background-muted uk-padding-small uk-padding-remove-top"
                        style={{ borderWidth: 1, borderColor: 'lightgrey', borderStyle: 'solid', borderTopWidth: 0, marginLeft: "40px"}}>
                        <label className="uk-form-label" hidden={!this.state.thirdPartyBeneficiarySettlement}>Third party entity</label>
                        <div className="uk-form-controls" hidden={!this.state.thirdPartyBeneficiarySettlement}>
                            {!this.state.readOnly ?
                                <DynamicSelect className={regularSelectClass} id="form-settlementapplicationform-beneficiaryId" placeholder='Select a Beneficiary...'
                                    data={this.state.listThirdPartyBenes} objValue={{ value: this.state.beneficiaryId }} getValue={this.handleBeneficiaryId.bind(this)} 
                                    disabled={disableIfFullyApplied || disableIfFromSettlements}/>
                                :
                                <p id="label-settlementapplicationform-beneficiaryId" style={{marginTop: '5px'}}>
                                    {this.state.beneficiaryId > 0 && this.state.listThirdPartyBenes.length > 0 ?
                                        this.state.listThirdPartyBenes.find(n => n.value === this.state.beneficiaryId).name : "-"}
                                </p>
                            }
                        </div>

                        <label className="uk-form-label" hidden={this.hideChequeInfo()}>Bank</label>
                        <div className="uk-form-controls uk-width-4-5" hidden={this.hideChequeInfo()}>
                            {!this.state.readOnly ? 
                                <DynamicSelect className={this.formatValidSelect(this.state.validations.chequeBankId)} id="form-settlementapplicationform-banks" placeholder='Select a Bank...'
                                    data={this.state.listBanks} objValue={{ value: this.state.chequeBankId }} getValue={this.handleChequeBank.bind(this)} 
                                    disabled={disableIfFullyApplied || disableIfFromSettlements}/>
                                :
                                <p id="label-settlementapplicationform-beneficiaryId" style={{marginTop: '5px'}}>
                                    {this.state.chequeBankId > 0 && this.state.listBanks.length > 0 ?
                                        this.state.listBanks.find(n => n.value === this.state.chequeBankId).name : "-"}
                                </p>
                            }
                        </div>
                    </div>
                    
                    {/*Line4*/}
                    <div className="uk-width-1-4" style={{ marginTop: 7 }}>
                        <label className="uk-form-label" >Date received</label>
                        {!this.state.readOnly ?
                            <DatePicker className={this.formatValidInput(this.state.validations.dateReceived)} id="form-settlementapplicationform-dateReceived" 
                                value={this.state.dateReceived} onDayChange={this.handleDateReceived.bind(this)} endDate={this.state.endDate} 
                                disabled={disableIfFullyApplied}/>
                            :
                            <p id="label-settlementapplicationform-dateReceived" style={{marginTop: '5px'}}>
                                {this.state.dateReceived !== "" ? formatDate(this.state.dateReceived) : "-"}
                            </p>
                        }
                    </div>
                    
                    <div className="uk-width-1-4" style={{ marginTop: 7 }}>
                        <label className="uk-form-label">Settlement reference no</label>
                        {!this.state.readOnly ?
                            <input className={regularInputClass} type="text" id="form-settlementapplicationform-settlementReferenceNo" 
                                value={this.state.settlementReferenceNo} 
                                onChange={this.handleSettlementReferenceNo.bind(this)} 
                                disabled={disableIfFullyApplied || disableIfFromSettlements}/>
                            :
                            <p id="label-settlementapplicationform-settlementReferenceNo" style={{marginTop: '5px'}}>
                                {this.state.settlementReferenceNo !== "" && this.state.settlementReferenceNo != null ?this.state.settlementReferenceNo : "-"}
                            </p>
                        }
                    </div>
                    
                    <div className="uk-width-1-4"></div>                    
                    <div className="uk-width-1-4"></div>

                    {/*Line5*/}
                    <div className="uk-width-1-2" style={{ marginTop: 7 }}>
                        <label className="uk-form-label">Nostro account</label>
                        <div className="uk-form-controls">
                            {!this.state.readOnly ?
                                <DynamicSelectWithSearch key={'ds-saf-na'}
                                    id={'ds-saf-na'}
                                    className={this.formatValidSelect(this.state.validations.nostroAccountId)}
                                    data={this.state.listNostroAccounts}
                                    placeholder='Select an Account...'
                                    getValue={this.handleNostroBankAccount.bind(this)}
                                    objValue={{ value: this.state.nostroBankAccountId }}
                                    disabled={disableIfFullyApplied} />
                                :
                                <p id="label-settlementapplicationform-nostroaccounts" style={{marginTop: '5px'}}>
                                    {this.state.nostroBankAccountId > 0 && this.state.listNostroAccounts.length > 0 ?
                                        this.state.listNostroAccounts.find(n => n.value === this.state.nostroBankAccountId).name : "-"}
                                </p>
                            }
                        </div>
                    </div>
                    
                    <div className="uk-width-1-2"></div>
                </div>

                {!this.state.readOnly && !disableIfFromSettlements && (
                    <div>
                        <button className="uk-button uk-button-green" type="button" onClick={e => this.handleSaveClickAskConfirmation(e, false)}
                            hidden={this.hideConfirmButton()}>{saveButtonText}</button>
                        <button className="uk-button uk-button-green" type="button" onClick={e => this.handleSaveClickAskConfirmation(e, true)}
                            hidden={this.hideSaveInPendingButton()}>Outstanding</button>
                        <button className="uk-button uk-button-green" type="button" onClick={this.handleClearClick.bind(this)}>Clear Fields</button>
                        <button className="uk-button uk-button-green" type="button" onClick={this.voidSettlement}
                            hidden={this.hideVoidButton()}>Void</button>
                    </div> )
                }

                <hr></hr>

                {additionalInfo}

                <AlertBox id="alert-settlement-Save"
                    type="Yes/No"
                    open={this.state.showAlertSave}
                    title="Confirm"
                    message={this.state.alertMessageSave}
                    yesClick={this.saveSettlement}
                    noClick={this.closeAlertSave}
                    onClose={this.closeAlertSave} />

                <AlertBox id="global-Alert"
                    type="Ok"
                    open={this.state.showAlert}
                    title={this.state.alertTitle}
                    message={this.state.alertMessage}
                    okClick={this.closeAlert}
                    onClose={this.closeAlert} />

                <AlertBox id="alert-void-settlement"
                    type="Yes/No"
                    open={this.state.showVoidSettlementAlert}
                    title="Confirm"
                    message={this.state.messageVoid}
                    yesClick={this.yesVoidSettlement}
                    noClick={this.closeVoidSettlementAlert}
                    onClose={this.closeVoidSettlementAlert} />

                <AlertBox id="alert-unapply-settlement"
                    type="Yes/No"
                    open={this.state.showUnapplySettlementAlert}
                    title="Confirm"
                    message={this.state.messageUnapplied}
                    yesClick={this.yesUnapplySettlement}
                    noClick={this.closeUnaplySettlementAlert}
                    onClose={this.closeUnaplySettlementAlert} />

                <AlertBox id="apply-settlements-alert" 
                    open={this.state.showApplySettlementsAlert}
                    title="Please confirm"
                    message={"You will apply: " + formatToCurrencyWithScale(amountTotalToApply, this.state.currencyID) + ' ' + this.state.currencyID}
                    type="Yes/No"
                    yesClick={this.yesApplySettlementsAlert.bind(this)}
                    noClick={this.noApplySettlementsAlert.bind(this)}
                />

                <AlertBox id="apply-current-settlement-alert"
                    open     = {this.state.showApplyCurrentSettlementsAlert}
                    title    = "Please confirm"
                    message  = {this.state.confirmCurrentElementMessage}
                    type     = "Yes/No"
                    yesClick = {this.yesApplyCurentSettlementsAlert}
                    noClick  = {this.noApplyCurrentSettlementsAlert}
                />

                <LoadingBox loading={this.state.loading || this.state.loadingSettlements}/>
            </div>
        )
        
        var settlementInformation = "Settlement Information - " + this.state.customerName;
        if(this.state.settlementID > 0) { settlementInformation = "Settlement ID: " + this.state.settlementID + " (" + this.state.customerName + ")"; }
        return(
            <div>
                <div className="breadcrumb-div">
                    <Breadcrumb separator=">">
                        <Breadcrumb.Item className="breadcrumb-item" onClick={this.handleBackLink.bind(this)}>{this.props.mainTitle}</Breadcrumb.Item>
                        <Breadcrumb.Item className="breadcrumb-item-bold">{settlementInformation}</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                {regularScreen}
            </div>
        )
    }
}